/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { TransportMiddlewareProps, ValidationInternalError } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const sendFetchRequestMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { url, requestInit } = req;

    if (!url) {
        res[TransportMiddlewareProps.ErrorResponse] = new ValidationInternalError('url');
        next(res);
    } else {
        ctx.httpRequestService.fetch(url as string, requestInit as RequestInit)
            .then((resp: Response) => {
                res.response = resp;
                next();
            });
    }
};
